import { render, staticRenderFns } from "./orthodontic-instructions.vue?vue&type=template&id=8445573c&scoped=true"
import script from "./orthodontic-instructions.vue?vue&type=script&lang=js"
export * from "./orthodontic-instructions.vue?vue&type=script&lang=js"
import style0 from "./orthodontic-instructions.vue?vue&type=style&index=0&id=8445573c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8445573c",
  null
  
)

export default component.exports